import { jsx as _jsx } from "react/jsx-runtime";
export const Container = props => (_jsx("div", Object.assign({ className: props.fluid ? 'container-fluid' : 'container' }, { children: props.children })));
